<img
  src="/assets/img/Icon-SS-Ampersand-RGB-Gold.png"
  alt="Sight & Sound Ampersand Logo"
  width="35"
  height="35"
/>
